import React from "react";
import { COMPONENT_TYPES } from "@/components/PageCluster/helpers/componentTypes";
import FAQ from "@/components/FAQ";
import { ClusterApiResponse } from "@/components/PageCluster/api/interface";
import { useAppSelector } from "@/redux/hooks";
import clusterDataSelector from "@/components/PageCluster/redux/selectors/clusterData";
import userAgentSelector from "@/components/PageCluster/redux/selectors/userAgent";
import ArticleComponent from "@/components/ArticleComponent";
import TopTips from "@/components/PagePiller/components/TopTips";
import PageIndex from "@/components/PagePiller/components/PageIndex";
import ContentImageDescComponent from "@/components/PagePiller/components/ContentImageDesc";
import QuotesCards from "@/components/QuotesCard";
import VideoWidgetComponent from "@/components/PagePiller/components/VideoWidget";
import ClusterActionCardsComponent from "@/components/PagePiller/components/ClusterActionCards";
import ClusterWeekSelection from "@/components/PageCluster/components/ClusterWeekSelection";
import styles from "../../PageCluster.module.scss";

const ComponentMapping = (props) => {
  const { data, clusterSlug, extraData } = props;
  const { registerRef, indexContent, elementRefs } = extraData;
  const componentType = data?.ComponentType;
  const clusterData: ClusterApiResponse = useAppSelector(clusterDataSelector);
  const userAgent = useAppSelector(userAgentSelector);
  const clusterDetails = clusterData?.data?.[0]?.attributes;
  const categorySlug = clusterDetails?.Category?.data?.attributes?.Slug;
  const pillarSlug = clusterDetails?.Pillar?.data?.attributes?.Slug;

  switch (componentType) {
    case COMPONENT_TYPES.Index:
      return <PageIndex data={indexContent} elementRefs={elementRefs} userAgent={userAgent} />;
    case COMPONENT_TYPES.ArticlesWithTagSlider:
      return (
        <ArticleComponent
          registerRef={registerRef}
          data={data}
          clusterSlug={clusterSlug}
          userAgent={userAgent}
          categorySlug={categorySlug}
          pillarSlug={pillarSlug}
        />
      );
    case COMPONENT_TYPES.FaqListWithTitle:
      return <FAQ data={data} />;
    case COMPONENT_TYPES.ContentImageDesc:
      return <ContentImageDescComponent registerRef={registerRef} data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.TopTips:
      return <TopTips registerRef={registerRef} data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.BannerWithImage:
      return <ClusterWeekSelection data={data} userAgent={userAgent} clusterSlug={clusterSlug} />;
    case COMPONENT_TYPES.Quote:
      return (
        <div className={` ${styles.quoteWrap} spacingBetweenSections`}>
          <QuotesCards data={data} />
        </div>
      );
    case COMPONENT_TYPES.VideoWidget2:
      return <VideoWidgetComponent data={data} userAgent={userAgent} />;
    case COMPONENT_TYPES.ClusterActionCards:
      return <ClusterActionCardsComponent data={data} userAgent={userAgent} />;

    default:
      return <></>;
  }
};

export default ComponentMapping;
